export default __webpack_public_path__ + "src/_images/CreditCard_Blue.png";